import { useCallback, useEffect, useState } from "react";
import { getUsersByClient } from "../../../core/services/keycloakApi";

export const useUserPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    upass: "",
    role_id: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleFormSuccess = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await getUsersByClient();
      const apiUsers = response?.data?.data || [];

      const normalizedUsers = apiUsers
        .sort((a, b) => (b.enabled ? -1 : 1))
        .map((u) => ({
          uid: u.id,
          id: u.id,
          uname: u.username,
          name: `${u.firstName || ""} ${u.lastName || ""}`.trim(),
          firstName: u.firstName || "",
          lastName: u.lastName || "",
          email: u.email || "",
          enabled: u.enabled,
          raw: u,
        }));

      setUsers(normalizedUsers);
      setSelectedUser((currentUser) => {
        if (!currentUser?.uid) return currentUser;

        return (
          normalizedUsers.find((user) => user.uid === currentUser.uid) ||
          null
        );
      });
    } catch (err) {
      setError("Failed to fetch users");
      setUsers([]);
      setSelectedUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (tabIndex === 0) fetchUsers();
  }, [fetchUsers, tabIndex]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setSnackbar({
      open: true,
      message: "User updated successfully!",
      severity: "success",
    });
    setIsEditing(false);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return {
    tabIndex,
    setTabIndex,
    users,
    selectedUser,
    setSelectedUser,
    isEditing,
    setIsEditing,
    loading,
    error,
    formData,
    setFormData,
    snackbar,
    handleFormSuccess,
    fetchUsers,
    handleChange,
    handleUpdate,
    handleSnackbarClose,
  };
};
